import { render, staticRenderFns } from "./TestLogin.vue?vue&type=template&id=5bda3d43&scoped=true&"
import script from "./TestLogin.vue?vue&type=script&lang=js&"
export * from "./TestLogin.vue?vue&type=script&lang=js&"
import style0 from "./TestLogin.vue?vue&type=style&index=0&id=5bda3d43&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../东方蚂蚁/e-shop/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bda3d43",
  null
  
)

export default component.exports